import { Cart, CartItem as CartItemType } from 'src/models/cart/_types';
import { Trainer } from 'src/models/trainer/_types';
import { Identifier } from 'src/types/utilityTypes';

import { ItemBrowser } from '../../../shared/SidebarDialog/ItemBrowser';

import { usePaymentDialogContext } from './PaymentDialogContext';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface ItemSelectorProps<T extends { id: Identifier }> {
  onSelect: (item: any, options?: any) => Promise<void>;
  onRemove: (item: CartItemType, index?: number) => void;
  cartItems: CartItemType[];
  trainer?: Trainer;
  cart: Cart | null;
  updateLocationId?: (locationId: Identifier) => void;
}

const ItemSelector = <T extends { id: Identifier }>({
  onSelect,
  onRemove,
  cartItems,
  trainer,
  cart,
  updateLocationId,
}: ItemSelectorProps<T>) => {
  const {
    selectedUser: user,
    selectedItemType,
    debouncedSearchValue,
    setSearchValue,
    searchValue,
  } = usePaymentDialogContext();

  return (
    <ItemBrowser
      user={user}
      selectedItemType={selectedItemType || null}
      searchValue={searchValue}
      onSearchChange={setSearchValue}
      debouncedSearchValue={debouncedSearchValue}
      onSelect={onSelect}
      onRemove={onRemove}
      selectedItems={cartItems}
      includeOnlineTraining={true}
      trainer={trainer}
      cart={cart}
      updateLocationId={updateLocationId}
    />
  );
};

export default ItemSelector;
